module.exports = require("/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/src/state/createStore")